import { render, staticRenderFns } from "./SucursalProductosInventarioResumen.vue?vue&type=template&id=595b345c&scoped=true&"
import script from "./SucursalProductosInventarioResumen.vue?vue&type=script&lang=js&"
export * from "./SucursalProductosInventarioResumen.vue?vue&type=script&lang=js&"
import style0 from "./SucursalProductosInventarioResumen.vue?vue&type=style&index=0&id=595b345c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595b345c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VCol,VContainer,VDivider,VIcon,VRow})
